import { render, staticRenderFns } from "./ListReservationCard.vue?vue&type=template&id=30f6847e&scoped=true&"
import script from "./ListReservationCard.vue?vue&type=script&lang=js&"
export * from "./ListReservationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f6847e",
  null
  
)

export default component.exports